
import request from '@/utils/request';

export default {
    addData(oid, data) {
        return request({
            url: '/organization/add',
            method: 'post',
            data
        });
    },
    updateData(oid,data) {
        return request({
            url: '/organization/update',
            method: 'post',
            data
        });
    },

    fetchData(oid) {
        return request({
            url: '/organization/findRecentChangedData',
            method: 'get',
            params: { oid }
        });
    },

    deleteData(oid,ids) {
        return request({
            url: '/organization/delete',
            method: 'delete',
            data: ids, // `ids` 作为请求体发送
        });
    },

    importData( oid,data) {
        return request({
            url: '/organization/import',
            method: 'post',
            params: { oid },
            data
        });
    },

    searchData(oid, keyword) {
        return request({
            url: '/organization/searchData',
            method: 'get',
            params: { oid,keyword }
        });
    }
};
